<template lang="html">
  <div>

    <c-confirm-dialog v-model="dialogSubmeterAprovacao" @yes="submeterAprovacao()" titulo="Submeter a ação para aprovação?">
      O cadastro da ação nesta plataforma não garante o registro! É necessário autuar um processo digital (com PDF da ação em anexo) na secretaria do setor de lotação do coordenador e aguardar deliberação da Câmara de Extensão. Maiores informações entre em contato através do e-mail suporte.proex@ufes.br
    </c-confirm-dialog>

    <c-confirm-dialog v-model="dialogSubmeterAprovacaoAcaoRegistroTardio" @yes="submeterAprovacao()" titulo="Submeter a ação e o relatório para aprovação?">
      O cadastro da ação e o preenchimento do relatório nesta plataforma não garantem o registro! É necessário autuar um processo digital contendo o PDF da ação, o PDF do relatório e a documentação comprobatória na secretaria do setor de lotação do coordenador e aguardar deliberação da Câmara de Extensão. Maiores informações entre em contato através do e-mail suporte.proex@ufes.br
    </c-confirm-dialog>

    <c-confirm-dialog v-model="dialogConcluirImportacao" @yes="concluirImportacao()" titulo="Concluir importação?">
      Depois que a importação for concluída a ação de extensão importada do SIEX passará para a situação "Ativa" no novo portal de projetos.
    </c-confirm-dialog>

    <c-confirm-dialog v-model="dialogExclusao" @yes="excluirAcao()" titulo="Deseja realmente excluir a ação?">
      Essa ação será excluída após clicar na opção "Sim".
    </c-confirm-dialog>

    <v-divider></v-divider>
    <v-card-actions v-if="administrador === true || projeto.assessor === true || (projeto.funcao != null && projeto.funcao.item === 1)">
      <v-btn v-if="projeto.situacao.item === 15 && (projeto.registroTardio === false || projeto.registroTardio === true && projeto.relatorioFinalHabilitado === true) && !extensao.registroSIEX" :disabled="administrador === false && projeto.assessor === true" class="text-xs-right" color="primary" @click="botaoSubmeterAprovacao()">Submeter para aprovação</v-btn>
      <v-btn v-if="projeto.situacao.item === 15 && extensao.registroSIEX" :disabled="administrador === false && projeto.assessor === true" class="text-xs-right" color="primary" @click="botaoConcluirImportacao()">Concluir Importação</v-btn>
      <v-tooltip top v-if="projeto.situacao.item === 16 && !extensao.registroSIEX">
        <v-btn disabled slot="activator" class="text-xs-right" color="primary" @click="botaoSubmeterAprovacao()">Submeter para aprovação</v-btn>
        <span slot="button"></span>
        <span>Essa ação já foi submetida para aprovação!</span>
      </v-tooltip>

      <v-tooltip top v-if="projeto.situacao.item === 15 && projeto.registroTardio === true && projeto.relatorioFinalHabilitado === false">
        <template v-slot:activator="{ on }">
          <div v-on="on" style="float: left;">
            <v-btn disabled class="text-xs-right, botaoSubmeterAprovacaoDesabilitado" color="primary">Submeter para aprovação</v-btn>
          </div>
        </template>
        <span>O administrador (PROEX) precisa primeiramente liberar o preenchimento do relatório técnico final!</span>
      </v-tooltip>

      <v-tooltip top v-if="projeto.situacao.item === 16 && extensao.registroSIEX">
        <v-btn disabled slot="activator" class="text-xs-right" color="primary" @click="botaoConcluirImportacao()">Concluir Importação</v-btn>
        <span slot="button"></span>
        <span>A importação já foi submetida!</span>
      </v-tooltip>

      <v-btn v-if="habilitaBotaoFinalizarAcao === true && projeto.situacao.item === 18" :disabled="administrador === false && projeto.assessor === true" class="text-xs-right" color="primary" @click="botaoFinalizarAcao()">Finalizar Ação</v-btn>

      <v-btn v-if="habilitaBotaoGerarPDFAcao === true && projeto.situacao.item !== 15" class="text-xs-right" color="primary" @click="toRelatorio">Gerar PDF da Ação</v-btn>

      <v-btn v-if="(administrador === true && (projeto.situacao.item === 15 || projeto.situacao.item === 16)) || ((projeto.funcao != null && projeto.funcao.item === 1 || projeto.assessor === true) && projeto.situacao.item === 15)"
      :disabled="administrador === false && projeto.assessor === true" class="text-xs-right" color="red lighten-1 white--text" @click="botaoExcluirAcao()">Excluir ação</v-btn>

      <v-spacer></v-spacer>
      <slot></slot>
      <div v-if="editar != null">
        <v-btn v-if="administrador === true || projeto.situacao.item !== 16" color="primary" text @click="toEditar" >{{this.nome_editar == null ? 'Editar' : this.nome_editar}}</v-btn>
        <v-tooltip top v-if="administrador !== true && projeto.situacao.item === 16">
          <v-btn disabled slot="activator" color="primary" text @click="toEditar" >{{this.nome_editar == null ? 'Editar' : this.nome_editar}}</v-btn>
          <span slot="button"></span>
          <span>Não é possível editar uma ação aguardando aprovação!</span>
        </v-tooltip>
      </div>
      <v-btn v-if="proxima != null" color="primary" text @click="toAvancar" >Avançar</v-btn>
    </v-card-actions>
    <v-card-actions v-if="habilitaBotaoGerarPDFAcao === true && administrador === false && (projeto.funcao == null || projeto.funcao.item !== 1) && projeto.assessor === false">
      <v-btn v-if="usuarioPROEX === true && projeto.situacao.item !== 15 && projeto.situacao.item !== 16" class="text-xs-right" color="primary" @click="toRelatorio">Gerar PDF da Ação</v-btn>
      <v-spacer></v-spacer>
      <v-btn v-if="proxima != null" color="primary" text @click="toAvancar" >Avançar</v-btn>
    </v-card-actions>
  </div>
</template>

<script>
  import ConfirmDialog from '@/components/c-confirm-dialog'
  import projetos from '@/utils/projetos'
  import { mapGetters, mapActions } from 'vuex'

  export default {
    props: ['projeto', 'extensao', 'proxima', 'editar', 'nome_editar', 'habilitaBotaoGerarPDFAcao', 'habilitaBotaoFinalizarAcao'],
    data: () => ({
      api_url: process.env.API_BASE_URL,
      dialogSubmeterAprovacao: false,
      dialogSubmeterAprovacaoAcaoRegistroTardio: false,
      dialogConcluirImportacao: false,
      dialogExclusao: false,
      dialogFinalizar: false,
      data: '',
      dataFormatada: '',
      menuData: false
    }),
    computed: {
      ...mapGetters('auth', ['administrador', 'usuarioPROEX'])
    },
    methods: {
      ...mapActions('ui', ['SHOW_GLOBAL_LOADING', 'HIDE_GLOBAL_LOADING', 'SHOW_SNACKBAR']),
      botaoSubmeterAprovacao: function () {
        if (this.projeto.registroTardio === true) {
          this.dialogSubmeterAprovacaoAcaoRegistroTardio = true
        } else {
          this.dialogSubmeterAprovacao = true
        }
      },
      submeterAprovacao: function () {
        this.SHOW_GLOBAL_LOADING({ globalLoadingTitle: 'Submetendo Ação.' })
        projetos.postSubmissaoAprovacao(this.projeto.idProjeto)
        .then(response => {
          this.SHOW_SNACKBAR({snackbarType: 'success', snackbarText: response.body.mensagem})
          if (this.relatorioHabilitadoAcaoRegistroTardio() === false) {
            this.$router.push({ name: 'ProjetoFormulario', params: {idProjeto: this.projeto.idProjeto} })
          } else {
            this.$router.push({ name: 'RelatoriosProjeto', params: {idProjeto: this.projeto.idProjeto} })
          }
          window.location.reload()
        })
        .catch(error => {
          console.log('Erro ao mandar o request' + error)
          this.SHOW_SNACKBAR({snackbarType: 'error', snackbarText: error.body.mensagem})
        })
        .finally(() => {
          this.HIDE_GLOBAL_LOADING({ globalLoadingTitle: 'Submetendo Ação.' })
        })
      },
      botaoConcluirImportacao: function () {
        this.dialogConcluirImportacao = true
      },
      // Verifica se o preenchimento do relatório final está habilitado para ações de extensão com registro tardio.
      relatorioHabilitadoAcaoRegistroTardio: function () {
        if (this.projeto.relatorioFinalHabilitado === true) {
          return true
        } else {
          return false
        }
      },
      concluirImportacao: function () {
        this.SHOW_GLOBAL_LOADING({ globalLoadingTitle: 'Concluindo importação...' })
        projetos.postConcluirImportacao(this.projeto.idProjeto)
        .then(response => {
          this.SHOW_SNACKBAR({snackbarType: 'success', snackbarText: response.body.mensagem})
          this.$router.push({ name: 'ProjetoFormulario', params: {idProjeto: this.projeto.idProjeto} })
          window.location.reload()
        })
        .catch(error => {
          console.log('Erro ao mandar o request' + error)
          this.SHOW_SNACKBAR({snackbarType: 'error', snackbarText: error.body.mensagem})
        })
        .finally(() => {
          this.HIDE_GLOBAL_LOADING({ globalLoadingTitle: 'Concluindo importação...' })
        })
      },
      botaoFinalizarAcao: function () {
        this.$router.push({ name: 'FinalizarAcao', params: {idProjeto: this.projeto.idProjeto} })
      },
      botaoExcluirAcao: function () {
        this.dialogExclusao = true
      },
      excluirAcao: function () {
        this.SHOW_GLOBAL_LOADING({ globalLoadingTitle: 'Excluindo ação...' })
        projetos.deleteProjeto(this.projeto.idProjeto)
        .then(response => {
          this.$router.push({ name: 'MeusProjetos' })
          this.SHOW_SNACKBAR({snackbarType: 'success', snackbarText: response.body.mensagem})
        })
        .catch(error => {
          console.log('Erro ao mandar o request' + error)
          this.SHOW_SNACKBAR({snackbarType: 'error', snackbarText: error.body.mensagem})
        })
        .finally(() => {
          this.HIDE_GLOBAL_LOADING({ globalLoadingTitle: 'Excluindo ação...' })
        })
      },
      toRelatorio: function () {
        this.$router.push({ name: 'Relatorio', params: {idProjeto: this.projeto.idProjeto} })
      },
      toEditar: function () {
        this.$router.push({ name: this.editar, params: {idProjeto: this.projeto.idProjeto} })
      },
      toAvancar: function () {
        this.$router.push({ name: this.proxima, params: {idProjeto: this.projeto.idProjeto} })
      }
    },
    components: {
      'c-confirm-dialog': ConfirmDialog
    }
  }
</script>

<style lang="css">

  .botaoSubmeterAprovacaoDesabilitado {
    margin-right: 0.5em;
  }

</style>



// WEBPACK FOOTER //
// c-card-footer.vue?75b4c3a6